import React from 'react'
import { FiAlertTriangle } from 'react-icons/fi'
import IDonor from '@interfaces/IDonor'
import ICustomImportDonor from '@interfaces/ICustomImportDonor'

type TreatmentDisplayMode = 'all' | 'selected-only' | 'reserved'

interface DonorTreatmentsProps {
  donor: IDonor | ICustomImportDonor
  availableTreatments: string[]
  selectedTreatment?: string
  treatmentDisplayMode: TreatmentDisplayMode
  isTreatmentEligible: boolean
}

const DonorTreatments: React.FC<DonorTreatmentsProps> = ({
  donor,
  availableTreatments,
  selectedTreatment,
  treatmentDisplayMode,
  isTreatmentEligible,
}) => {
  const mappedSelectedTreatment = selectedTreatment === 'Inseminação' ? 'IIU' : selectedTreatment

  const allTreatments = [
    { key: 'ICSI', label: 'ICSI', price: donor.icsi_price },
    { key: 'FIV', label: 'FIV', price: donor.fiv_price },
    { key: 'IIU', label: 'Inseminação', price: donor.iiu_price },
  ]

  const isReservedMode = treatmentDisplayMode === 'reserved'
  const isSelectedOnly = treatmentDisplayMode === 'selected-only' || isReservedMode
  const selected = allTreatments.find(t => t.key === mappedSelectedTreatment)

  return (
    <div className="donor-card__treatments-section">
      {isSelectedOnly && selected ? (
        <div className="treatment-selected">
          <div className="treatment-selected__card">
            <span className="treatment-selected__label">{selected.label}</span>
            {isReservedMode ? (
              <span className="treatment-selected__price">
                {selected.price ? `R$ ${selected.price}` : 'Sem Valor'}
              </span>
            ) : (
              <span className="treatment-selected__price">
                {availableTreatments.includes(selected.key)
                  ? (selected.price ? `R$ ${selected.price}` : 'Sem Valor')
                  : 'Indisponível'}
              </span>
            )}
          </div>
        </div>
      ) : (
        <div className="treatments-wrapper">
          {allTreatments.map((treatment) => {
            const isAvailable = availableTreatments.includes(treatment.key)
            const price = treatment.price ? `R$ ${treatment.price}` : 'Sem Valor'
            const isSelected = selectedTreatment === treatment.key || (selectedTreatment === 'Inseminação' && treatment.key === 'IIU')

            const className = [
              'treatment-card',
              isAvailable ? 'treatment-card--available' : 'treatment-card--disabled',
              isSelected ? 'treatment-card--selected' : '',
            ].filter(Boolean).join(' ')

            return (
              <div
                key={treatment.key}
                className={className}
              >
                <span className="treatment-card__label">{treatment.label}</span>
                <span className="treatment-card__price">{isAvailable ? price : 'Indisponível'}</span>
              </div>
            )
          })}
        </div>
      )}
      {selectedTreatment && !isTreatmentEligible && !isReservedMode && (
        <div className="incompatible-banner">
          <FiAlertTriangle size={16} />
          <span>Incompatível com {selectedTreatment}</span>
        </div>
      )}
    </div>
  )
}

export default DonorTreatments
